import React, { Component } from "react";
import history from "../utils/history";
import { Navigate } from "react-router-dom";
import Terms from "./parts/terms";
import WImg from "../media/logo-default.png";
import { toast } from "react-toastify";
import { API_URL, AVATARS_BUCKET } from "../config";
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import {
  Container,
  Typography,
  Box,
  TextField,
  Button,
  CircularProgress,
  Modal,
  Link,
} from "@mui/material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: 800,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

class Register extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      userName: "",
      loading: false,
      showTerms: false,
    };
  }

  closeTerms = () => {
    this.setState({ showTerms: false });
  };

  openTerms = () => {
    this.setState({ showTerms: true });
  };

  handleFirstName = (e) => {
    if (this._isMounted) this.setState({ firstName: e.target.value });
  };

  handleLastName = (e) => {
    if (this._isMounted) this.setState({ lastName: e.target.value });
  };

  handleUserName = (e) => {
    if (this._isMounted) this.setState({ userName: e.target.value });
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  dataURItoBlob(dataURI) {
    var binary = atob(dataURI.split(",")[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: "image/png" });
  }

  uploadLogo = async () => {
    const s3 = new S3Client({
      region: "us-east-1",
      credentials: this.props.AWS?.config?.credentials,
    });

    let s3params = {
      Body: this.dataURItoBlob(WImg),
      Bucket: AVATARS_BUCKET,
      Key: this.props.user.sub + ".png",
      ServerSideEncryption: "AES256",
      ACL: "public-read",
      ContentType: "image/png",
    };

    try {
      await s3.send(new PutObjectCommand(s3params));
      console.log("default image uploaded");
      history.push("/getting-started");
      window.location.reload(false);
    } catch (err) {
      toast.warn("Something went wrong with registration");
      if (this._isMounted) this.setState({ loading: false });
    }
  };

  submitRegistration = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    console.log("sending form");

    this.setState({ loading: true });
    if (
      this.state.firstName === "" ||
      this.state.lastName === "" ||
      this.state.userName === ""
    ) {
      this.setState({ loading: false });
      console.log("there's some empty stuff");
      toast.warn("Please fill in all required fields");
    } else {
      try {
        const token = this.props.token;

        // Determine source for account type detection
        const source = window.location.hostname.includes('store') ? 'store' : 'main';

        const body = JSON.stringify({
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          username: this.state.userName,
          source: source // Add source for backend account type determination
        });

        const response = await fetch(API_URL + "/users/v1/register", {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: body,
          method: "POST",
        });

        const responseData = await response;
        const responseJson = await responseData.json();

        if (responseData.status === 200) {
          this.uploadLogo();
          console.log(responseData);
          console.log("responseData", responseJson);
        } else {
          toast.warn(
            "Something went wrong: server returned " + responseData.status
          );
          if (this._isMounted) this.setState({ loading: false });
        }

        console.log("ASYNC RESPONSE COMPLETE", responseData);
      } catch (error) {
        console.warn("ASYNC  SUBMIT FAILURE", error);
        toast.warn("Registration error: " + error.message);
        this.setState({ loading: false });
      }
    }
  };

  render() {
    if (this.props.isRegistered) return <Navigate to="/dashboard" />;

    return (
      <>
        <Modal open={this.state.showTerms} onClose={this.closeTerms}>
          <Box sx={modalStyle}>
            <Terms />
          </Box>
        </Modal>
        <Container maxWidth="sm" sx={{ mt: 5, pt: 5 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Before you start...
          </Typography>
          <Typography variant="body1" gutterBottom>
            We'll need you to fill up the following details.
          </Typography>
          <Box
            component="form"
            onSubmit={this.submitRegistration}
            sx={{
              bgcolor: "background.paper",
              p: 3,
              mt: 2,
              borderRadius: 1,
              boxShadow: 3,
            }}
            noValidate
          >
            <TextField
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              autoComplete="username"
              margin="normal"
              onChange={this.handleUserName}
            />

            <TextField
              required
              fullWidth
              id="firstName"
              label="First Name"
              name="firstName"
              autoComplete="given-name"
              margin="normal"
              onChange={this.handleFirstName}
            />

            <TextField
              required
              fullWidth
              id="lastName"
              label="Last Name"
              name="lastName"
              autoComplete="family-name"
              margin="normal"
              onChange={this.handleLastName}
            />

            <Typography variant="body2" sx={{ mt: 1 }}>
              By registering, I hereby accept the{" "}
              <Link component="button" type="button" onClick={this.openTerms}>
                Terms of Service
              </Link>{" "}
              of Shieldshot
            </Typography>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={this.state.loading}
            >
              {this.state.loading ? (
                <CircularProgress size={24} />
              ) : (
                "Let's Go"
              )}
            </Button>
          </Box>
        </Container>
      </>
    );
  }
}

export default Register;
